export const toUnixTime = (time: string): number => {
    return Math.floor(new Date(time).getTime() / 1000);
};
